// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2019-12-24 03:13:29 +0100 (Tue, 24 Dec 2019) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 106724 $
//  Purpose   : auth reducers
// =============================================================================
// ---Framework imports
import {handleAction} from 'uix/actions'
import {setWebauthn} from './actions'
import {has, dict} from 'ldash'
import log from 'uix/logging'
import {decodeRequestWithAuth} from 'uix/routing'

import {getUserData, setUserData} from './actions'

// ---Globals
export const data = [
  handleAction(
    setUserData,
    ({users, ...data}, {payload}) => ({...data, users: {...users, ...payload}}),
    {users: {}} // initial state
  ),
  handleAction(getUserData, ({users, ...data}, {payload}) => ({
    ...data,
    users: payload.puid
      ? {...users, [payload.puid]: null}
      : {...users, ...dict(payload.puids.map(puid => [puid, null]))},
  })),
]

export const meta = [
  handleAction(
    setWebauthn,
    (meta, {payload}) => {
      return {...meta, webauthn: {...meta.webauthn, ...payload}}
    },
    {webauthn: {}} // initial state
  ),

  handleAction('SET_USER', (meta, {payload}) => {
    return {...meta, user: {...payload.user, isGuest: payload.user.groups.includes('guest')}}
  }),

  handleAction('LOGIN_SUCCESS', (meta, {payload}) => {
    if (has(meta, 'request.query.loginTargetParams')) {
      // restore original request
      let {loginTarget, ...request} = meta.request
      let decoded = decodeRequestWithAuth(
        loginTarget.params,
        loginTarget.query,
        action.more.config()
      )
      meta = {...meta, request: {...request, ...decoded}}
    }
    return {...meta, loginFailure: null}
  }),

  handleAction('LOGIN_FAILED', (meta, {payload}) => ({...meta, loginFailure: {...payload}})),
  handleAction('RUN_LOGOUT', (meta, {payload}) => ({...meta, loginActive: false})),
]
